import { ParseError, parsePhoneNumber } from 'libphonenumber-js';
import { lowerFirst } from 'lodash-es';

export function createAlarmRecipientPlaceholder() {
    return `${gettext('E-mail address')} ${gettext('OR')} ${lowerFirst(gettext('Phone number'))}`;
}

export function createInvalidEmailOrPhoneText() {
    return `${gettext('INVALID')} ${lowerFirst(createAlarmRecipientPlaceholder())}.`;
}

export function isEmailValid(email) {
    return /^.+@.+(?:\.[a-zA-Z]+)*?$/.test(email);
}

export function isPhoneNumberValid(v) {
    function handleInvalidPhoneNumber(p) {
        if (!NON_CONFORMING_COUNTRIES) {
            return false;
        }

        const countryCallingCode = parseInt(p.countryCallingCode, 10);

        return NON_CONFORMING_COUNTRIES.indexOf(countryCallingCode) > -1 && p.isPossible();
    }

    try {
        const phoneNumber = parsePhoneNumber(v);
        const isEmail = v.includes('@');
        const isPhoneNumber = phoneNumber.isValid() || handleInvalidPhoneNumber(phoneNumber);
        return !isEmail && isPhoneNumber;
    } catch (error) {
        if (error instanceof ParseError) {
            return false;
        }

        throw error;
    }
}
